import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { addCsrfHeader } from '../utils/csrfUtils';

export const useAddSingleMealToMealPlan = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [error, setError] = useState(null);
  const { sessionToken } = useAuth();

  const addSingleMealToMealPlan = async (mealPlanId, appUserId, mealOfDay, servingSize, recipeId, position) => {
    setIsAdding(true);
    setError(null);

    try {
      if (!sessionToken) {
        throw new Error('No valid session found');
      }

      // Add CSRF token and auth header
      const headers = await addCsrfHeader({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionToken}`
      });

      const response = await fetch('/api/v1/meal/add_single_meal_to_meal_plan', {
        method: 'POST',
        headers,
        body: JSON.stringify({
          meal_plan_id: mealPlanId,
          meal_of_day: mealOfDay,
          serving_size: servingSize,
          recipe_id: recipeId, // Optional - if null, will select random recipe
          position: position
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to add meal to meal plan');
      }

      const data = await response.json();
      console.log('Meal added to meal plan successfully:', data);
      return data;
    } catch (err) {
      setError(err.message);
      console.error('Error adding meal to meal plan:', err);
      throw err;
    } finally {
      setIsAdding(false);
    }
  };

  return {
    addSingleMealToMealPlan,
    isAdding,
    error
  };
};

export default useAddSingleMealToMealPlan;
